
const DOCUMENT = {
    fileName: true,
    displayName: true,
    documentType: true,
    metadata: true,
    content: true,
}
const RESPONSE = {
    id: true,
    externalId: true,
    externalActivityType: true,
    documentType: true,
    shipmentId: true,
    commonCarrierId: true,
    documents: DOCUMENT,
    atType: true,
    atBaseType: true,
}


export class FetchDocumentModel {
    /**
   *
   * @param shipmentId
   * @param sourceTms
   * @param documentType
   * @param documentNumber
   */
    private readonly getDocumentDetails: any = {
        shipmentId: "",
        sourceTms: "",
        documentType: "",
        documentNumber:""
    };

    set shipmentId(value) {
        this.getDocumentDetails.shipmentId = value;
    }

    get shipmentId() {
        return this.getDocumentDetails.shipmentId;
    }

    set sourceTms(value) {
        this.getDocumentDetails.sourceTms = value;
    }

    get sourceTms() {
        return this.getDocumentDetails.sourceTms;
    }
    set documentType(value) {
        this.getDocumentDetails.documentType = value;
    }

    get documentType() {
        return this.getDocumentDetails.documentType;
    }
    set documentNumber(value) {
        this.getDocumentDetails.documentNumber = value;
    }

    get documentNumber() {
        return this.getDocumentDetails.documentNumber;
    }
    getDocument() {
        return {
            query: {
                fetchDocument: {
                    __args: {
                        request: {
                            shipmentId : this.getDocumentDetails.shipmentId,
                            sourceTms : this.getDocumentDetails.sourceTms,
                            documentType : this.getDocumentDetails.documentType,
                            documentNumber : this.getDocumentDetails.documentNumber
                        },
                    },
                    ...RESPONSE,
                },
            },
        };
    }
}
